import { EGiftType, IItemGiftInfo } from "@interfaces/user/daily";
import { FC, PropsWithChildren } from "react";
import { Item } from "@constructor/components/features/items";
import { useDailyGiftContext } from "./context";

const DailyGift: FC<PropsWithChildren> = ({ children }) => {
    const gift = useDailyGiftContext();

    if (!gift) {
        return null;
    }

    if (gift.giftType === EGiftType.ItemGift) {
        const info = gift.giftInfo as IItemGiftInfo;
        return (
            <Item item_id={info.itemId}>
                {children}
            </Item>
        )
    }
    else {
        return (
            <>{children}</>
        )
    }
}

export default DailyGift;
